import { Injectable } from "@angular/core";
import { SessionStorageModel } from "../shared/SessionStorageModel";

@Injectable({
  providedIn: "root",
})

export class SessionStorageService {
  private data: { [key: string]: any } = {};
  private sessionStorageModel: SessionStorageModel = new SessionStorageModel();
  constructor() {}

  public setItem<T>(key: string, value: T): void {
    try {
      this.data[key] = value;
    } catch (error) {
      console.error("Error storing "+ key +" in custom session storage:", error);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const storedValue = this.data[key];
      return storedValue ? storedValue : null;
    } catch (error) {
      console.error("Error retrieving " + key + " from session storage:", error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      delete this.data[key];
    } catch (error) {
      console.error('Error removing '+ key +' from custom session storage:', error);
    }
  }

  public setApigeeToken(value: string) {
    this.sessionStorageModel.ApigeeToken = value;
  }

  public getApigeeToken(): string {
    return this.sessionStorageModel.ApigeeToken;
  }

  removeApigeeToken(key: string) {
    this.sessionStorageModel.ApigeeToken = "";
  }

  clear() {
    this.data = {};
    this.sessionStorageModel = new SessionStorageModel();
  }
}
